import src from "IMAGE";
export default { src, width: 1831, height: 1703, blurWidth: 0, blurHeight: 0};
